// Duplicado de fitclutch-mobile/src/config/equipmentIcons.js (só a parte
// MOCK_SLUG_TO_EQUIPMENT_ICON, usada pelo quickWorkoutGenerator.js pra
// filtrar exercício por equipamento disponível) — mesmo mapeamento, sem os
// ícones (não usados na tela de prévia do plano).
export const MOCK_SLUG_TO_EQUIPMENT_ICON = {
  'push-up-standard': 'bodyweight',
  'bench-press-dumbbell': 'dumbbell',
  'barbell-squat': 'barbell',
  'bodyweight-lunge': 'bodyweight',
  'bent-over-row-dumbbell': 'dumbbell',
  'lateral-raise-dumbbell': 'dumbbell',
  'barbell-bench-press': 'barbell',
  'incline-barbell-bench-press': 'barbell',
  'incline-dumbbell-fly': 'dumbbell',
  'chest-dip-assisted': 'leverage_machine',
  'pull-up': 'bodyweight',
  'lat-pulldown': 'cable',
  'bent-over-row-barbell': 'barbell',
  'seated-cable-row': 'cable',
  'dumbbell-deadlift': 'dumbbell',
  'military-press-barbell': 'barbell',
  'seated-shoulder-press': 'dumbbell',
  'front-raise-shoulder': 'dumbbell',
  'face-pull-cable': 'cable',
  'barbell-curl': 'barbell',
  'dumbbell-curl-standing': 'dumbbell',
  'concentration-curl': 'dumbbell',
  'hammer-curl': 'dumbbell',
  'seated-barbell-curl': 'barbell',
  'triceps-pushdown-cable': 'cable',
  'close-grip-bench-press': 'barbell',
  'skull-crusher-dumbbell': 'dumbbell',
  'triceps-kickback-dumbbell': 'dumbbell',
  'ring-dip': 'suspension',
  'leg-press-45': 'sled_machine',
  'stiff-leg-deadlift': 'barbell',
  'calf-raise-standing': 'bodyweight',
  'crunch-basic': 'bodyweight',
  'front-plank': 'bodyweight',
  'russian-twist': 'bodyweight',
  'bicycle-crunch': 'bodyweight',
  'side-plank': 'bodyweight',
  'glute-bridge': 'bodyweight',
  'hip-thrust-barbell': 'barbell',
  'glute-bridge-single-leg': 'bodyweight',
  'glute-bridge-band': 'resistance_band',
  'wrist-curl-barbell': 'barbell',
  'reverse-wrist-curl-dumbbell': 'dumbbell',
  'hand-gripper': 'bodyweight',
  'weighted-hand-grip': 'weighted',
};
